import { Button, Typography } from '@breetometer/components';
import { CopyIcon } from 'BreetAssets';
import { Amount, ImageComponent, TransactionDetails } from 'BreetComponents';
import { copyToClipboard, truncateWithEllipsis } from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';

import type { ICryptoTransactionDetailsViewProps } from './CryptoTransactionDetails.helpers';

const CryptoTransactionDetailsView = ({
	formValues,
	tokenAvatar,
	networkAvatar,
	networkFee,
	receiveAmount,
	handleVerification,
	currencySymbol,
	type,
	rate,
	totalAmount,
}: ICryptoTransactionDetailsViewProps) => {
	const currencyOutput = useCurrencyOutput();

	return (
		<div className='transaction-details payment-request-form_usdDestination'>
			<TransactionDetails.Content>
				<TransactionDetails.Row
					label={type === 'withdraw-usd' ? 'USD Amount:' : 'Amount'}
					value={
						<>
							{currencySymbol} <Amount>{currencyOutput(formValues.amount)}</Amount>
						</>
					}
				/>

				{type === 'buy-crypto' && (
					<>
						<TransactionDetails.Row
							label='Rate:'
							value={<Amount>{rate}</Amount>}
						/>

						<TransactionDetails.Row
							label='Total Amount:'
							value={
								<>
									$ <Amount>{currencyOutput(totalAmount)}</Amount>
								</>
							}
						/>
					</>
				)}

				<TransactionDetails.Row
					label='Network Fee:'
					value={
						<>
							$ <Amount>{currencyOutput(networkFee)}</Amount>
						</>
					}
				/>

				<TransactionDetails.Row
					label='Estimated Receive Amount:'
					value={
						<>
							$ <Amount>{currencyOutput(receiveAmount)}</Amount>
						</>
					}
				/>

				<TransactionDetails.Row label='Address:'>
					<TransactionDetails.RowRight>
						<div className='transaction-details_row-content transaction-details_row-position-end'>
							<Typography className='transaction-details_content_row_value color-neutral-50'>
								{truncateWithEllipsis(formValues.receiverAddress)}
							</Typography>

							<CopyIcon
								variant='colored'
								focusable
								aria-label='Copy wallet address'
								role='button'
								tabIndex={0}
								onClick={copyToClipboard(formValues.receiverAddress, 'Wallet Address copied successfully')}
								type='button'
								className='cursor_pointer'
							/>
						</div>
					</TransactionDetails.RowRight>
				</TransactionDetails.Row>

				<TransactionDetails.Row label='Coin:'>
					<TransactionDetails.RowRight>
						<div className='transaction-details_row-content transaction-details_row-position-end'>
							<ImageComponent
								src={tokenAvatar}
								alt='token'
								className='transaction-details_row-img'
							/>
							<Typography className='transaction-details_content_row_value color-neutral-50'>{formValues.token}</Typography>
						</div>
					</TransactionDetails.RowRight>
				</TransactionDetails.Row>

				<TransactionDetails.Row label='Destination Network:'>
					<TransactionDetails.RowRight>
						<div className='transaction-details_row-content transaction-details_row-position-end'>
							<ImageComponent
								src={networkAvatar}
								alt='network'
								className='transaction-details_row-img'
							/>
							<Typography className='transaction-details_content_row_value color-neutral-50'>{formValues.network}</Typography>
						</div>
					</TransactionDetails.RowRight>
				</TransactionDetails.Row>

				<TransactionDetails.Row
					label='Wallet Name:'
					value={formValues.walletName}
				/>
			</TransactionDetails.Content>

			<div className='transaction-details_balance bg-primary-400 border-dark-navy'>
				<Typography className='color-neutral-50'>1 USD = 1 USDT = 1 USDC</Typography>
			</div>

			<Button
				label={`Send ${currencySymbol} ${currencyOutput(formValues.amount)}`}
				className='right-sheet_cta_fullwidth'
				type='button'
				onClick={handleVerification}
			/>
		</div>
	);
};

export default CryptoTransactionDetailsView;
